import {
  Button,
  FormLabel,
  Grid,
  GridItem,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { WhatsSchema } from "schema";
import { postApi } from "services/api";

const WhatsAppForm = (props) => {
  //console.log(props, "...");
  const { onClose, isOpen, fetchData } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [contactData, setContactData] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  // //console.log("sender data",user)

  const contactList = useSelector((state) => state?.contactData?.data);
  //console.log("sender data .........", contactList);

  const initialValues = {
    sender: user ? `${user.firstName} ${user.lastName}`.trim() : "",
    recipient: props?.leadContact?.leadName || "",
    recipientNumber: props?.leadContact?.leadPhoneNumber || "",
    message: "",
    startDate: "",
    createBy: user?._id || "",
    createByLead: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: WhatsSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      handleAddData(values);
      resetForm();
      onClose();
    },
  });

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  //   const handleAddData = async (data) => {
  //     try {
  //       setIsLoading(true);

  //       let formattedData = {
  //         ...data,
  //         startDate: new Date(data.startDate),
  //       };
  //       let response = await postApi("api/whatsapp/add", values);
  //       //console.log("Data response:", response);
  //       if (response.status === 200) {
  //         props.onClose();
  //         fetchData(1);
  //         // setAction((pre) => !pre)
  //       }
  //     } catch (e) {
  //       //console.log("Error adding data:", e);
  //       toast.error("Failed to add WhatsApp message");
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  const handleAddData = async (data) => {
    try {
      setIsLoading(true);

      let formattedData = {
        ...data,
        startDate: new Date(data.startDate),
      };
      let response = await postApi("api/whatsapp/add", formattedData);
      //console.log("Data response:", response);

      const recipientNumber = data.recipientNumber;
      if (recipientNumber) {
        redirectToWhatsApp(recipientNumber);
      } else {
        toast.error("Recipient number is missing");
      }
    } catch (e) {
      //console.log("Error adding data:", e);
      toast.error("Failed to add WhatsApp message");
    } finally {
      setIsLoading(false);
    }
  };

  // Function to redirect to WhatsApp
  const redirectToWhatsApp = (number) => {
    const whatsappUrl = `https://wa.me/${number}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent height={"580px"}>
        <ModalHeader>Add WhatsApp Message</ModalHeader>
        <ModalCloseButton />
        <ModalBody overflowY={"auto"} height={"400px"}>
          <Grid templateColumns="repeat(12, 1fr)" gap={3}>
            <GridItem colSpan={{ base: 12 }}>
              <FormLabel>
                Sender<Text color="red">*</Text>
              </FormLabel>
              <Input
                type="text"
                value={values.sender}
                name="sender"
                isReadOnly
              />
            </GridItem>

            <GridItem colSpan={{ base: 12 }}>
              <FormLabel>
                Recipient<Text color="red">*</Text>
              </FormLabel>
              <Input
                type="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.recipient}
                name="recipient"
                placeholder="Recipient Name"
                readOnly
              />
              <Text color="red">
                {errors.recipient && touched.recipient && errors.recipient}
              </Text>
            </GridItem>

            <GridItem colSpan={{ base: 12 }}>
              <FormLabel>
                Recipient Number<Text color="red">*</Text>
              </FormLabel>
              <Input
                type="text"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.recipientNumber}
                name="recipientNumber"
                placeholder="Recipient Number"
                readOnly
              />
              <Text color="red">
                {errors.recipientNumber &&
                  touched.recipientNumber &&
                  errors.recipientNumber}
              </Text>
            </GridItem>

            <GridItem colSpan={{ base: 12 }}>
              <FormLabel>
                Message<Text color="red">*</Text>
              </FormLabel>
              <Textarea
                resize={"none"}
                placeholder="Write your message here"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.message}
                name="message"
              />
              <Text color="red">
                {errors.message && touched.message && errors.message}
              </Text>
            </GridItem>

            <GridItem colSpan={{ base: 12 }}>
              <FormLabel>
                Date<Text color="red">*</Text>
              </FormLabel>
              <Input
                type="datetime-local"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.startDate}
                name="startDate"
              />
              <Text color="red">
                {errors.startDate && touched.startDate && errors.startDate}
              </Text>
            </GridItem>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button
            size="sm"
            variant="brand"
            me={2}
            disabled={isLoading}
            onClick={() => {
              handleSubmit();
              onClose();
            }}
          >
            {isLoading ? "Saving..." : "Save"}
          </Button>
          <Button
            variant="outline"
            colorScheme="red"
            size="sm"
            onClick={() => {
              formik.resetForm();
              onClose();
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default WhatsAppForm;
